// https://blockly-demo.appspot.com/static/demos/blockfactory/index.html#pmhydb
import { translate } from '../../../../../common/i18n';
import { insideTrade } from '../../relationChecker';
import config from '../../../../common/const';
import { expectValue } from '../shared';
import theme from '../../theme';

Blockly.Blocks.copy_trading = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Copy Trading'));
        this.appendValueInput('TOKENS')
            .setCheck(null)
            .appendField(translate('List of Tokens'));
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour('#f2f2f2');
        this.setTooltip(
            translate(
                'Use a list of tokens (strings) to send the copies to the token\'s accounts. Insert this block at \'Define your trade contract\''
            )
        );
    },
    onchange: function onchange(ev) {
        insideTrade(this, ev, 'Definitions');
    },
};
Blockly.JavaScript.copy_trading = block => {
    const tokens = expectValue(block, 'TOKENS');
    const code = `Bot.getCopyTradingTokens(${tokens});`;
    return code;
};
